<telxl-shared-overlay-modal
    [size]="
        uploaded().length === 0 &&
        uploader().total === uploader().complete &&
        issues().length === 0
            ? 'md'
            : 'lg'
    "
    contentClass="h-100"
    bodyClass="pt-0 pb-0"
    footerClass="pt-3"
>
    <ng-template #modalHeader>
        <header
            class="d-flex justify-content-between align-items-center w-100"
            aria-label="Upload Modal Header"
        >
            <h2 class="font-lg weight-medium px-2 pt-2 mb-0">Attachments</h2>

            <telxl-button
                colour="secondary"
                size="lg"
                cdkOverlayOrigin
                #closeBtn="cdkOverlayOrigin"
                (buttonClick)="close(false)"
                (keydown.enter)="close(false)"
            >
                <i class="fa-light fa-lg fa-xmark"></i>
            </telxl-button>
        </header>
    </ng-template>

    <ng-template #modalBody>
        <div
            class="d-flex w-100"
            [class.h-100]="
                uploaded().length === 0 &&
                uploader().total === uploader().complete &&
                issues().length === 0
            "
        >
            <telxl-shared-dropzone
                [status]="state()"
                [maxSize]="maximum()"
                (dropped)="onFilesDropped($event)"
            />
        </div>

        @if (uploader().total !== uploader().complete) {
            <telxl-shared-uploading [upload]="uploader()" />
        } @else if (issues().length > 0) {
            @for (fileEntry of issues(); track fileEntry.id) {
                <telxl-shared-file
                    [file]="fileEntry"
                    (delete)="onFileDeleted($event)"
                />
            }
        }

        @if (uploaded().length > 0) {
            <hr />
            <div
                class="d-flex align-items-center justify-content-center position-relative"
            >
                <div>All Files</div>
                <div class="pill">
                    <span
                        class="badge rounded-pill status-pill weight-normal"
                        [class.warning]="remainingSize() < maximumSize() / 2"
                        [class.danger]="remainingSize() < maximumSize() / 10"
                    >
                        {{ sanitizedRemaining }}mb Remaining
                        <i
                            placement="top"
                            class="fa-lg fa-light fa-circle-info ms-1"
                            tooltipClass="tooltip-no-wrap"
                            container="body"
                            [ngbTooltip]="`${total()}mb/${maximum()}mb used`"
                            [style.margin-top.px]="8"
                            [style.cursor]="'pointer'"
                        ></i>
                    </span>
                </div>
            </div>
            <div class="scroll-container mt-2">
                @for (fileEntry of uploaded(); track fileEntry.id) {
                    <telxl-shared-file
                        [file]="fileEntry"
                        (delete)="onFileDeleted($event)"
                    />
                }
            </div>
        }
    </ng-template>

    <ng-template #modalFooter>
        @if (uploaded().length > 0 || hasChanges()) {
            <div class="d-flex align-items-center justify-content-center w-100">
                <telxl-button
                    colour="primary"
                    [outline]="true"
                    [disabled]="
                        !hasChanges() ||
                        uploading().length > 0 ||
                        state() !== 'upload'
                    "
                    (buttonClick)="commit()"
                >
                    Complete
                </telxl-button>
            </div>
        }
    </ng-template>
</telxl-shared-overlay-modal>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="closeBtn"
    [cdkConnectedOverlayOpen]="originReady() && confirmationOpen()"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayDisableClose]="true"
    [cdkConnectedOverlayBackdropClass]="'confirmation-backdrop'"
    [cdkConnectedOverlayPanelClass]="'confirmation-panel'"
    [cdkConnectedOverlayScrollStrategy]="overlay.scrollStrategies.block()"
    [cdkConnectedOverlayPositions]="positions"
>
    <div tabindex="0" (keydown.escape)="dismiss()" cdkTrapFocus>
        <telxl-shared-confirmation (confirm)="close(true)" (deny)="dismiss()" />
    </div>
</ng-template>
